// GENERATED from rooms.store by tools/room-store.js — do not edit.
// Edit the store (or the knobs app Rooms tab), then re-run the generator.
// The store is the single source of truth; this module is its projection
// the whole codebase imports (the generator's furnishing, the lobby's
// floor select chain, the arena's room select, the editors' lists).
export const ROOMS_DATA = [
  {
    "id": 0,
    "name": "Frozen",
    "floorTile": "frost",
    "architecture": "civic-stone-v1",
    "wear": 24,
    "obstacles": [
      { "type": "pond", "algo": "cluster", "min": 1, "max": 6, "sight": "low" },
    ],
  },
  {
    "id": 1,
    "name": "Hell",
    "floorTile": "ember",
    "architecture": "civic-stone-v1",
    "wear": 24,
    "obstacles": [
      { "type": "pond", "algo": "cluster", "min": 6, "max": 6, "sight": "low" },
      { "type": "table", "algo": "cluster", "min": 6, "max": 6, "sight": "low" },
    ],
  },
  {
    "id": 2,
    "name": "Death",
    "floorTile": "umbral",
    "architecture": "civic-stone-v1",
    "wear": 24,
    "obstacles": [
      { "type": "pond", "algo": "cluster", "min": 3, "max": 6, "sight": "low" },
      { "type": "table", "algo": "cluster", "min": 3, "max": 6, "sight": "low" },
      { "type": "wall", "algo": "cluster", "min": 3, "max": 6, "sight": "tall" },
    ],
  },
  {
    "id": 3,
    "name": "Godslayer",
    "floorTile": "bone",
    "architecture": "civic-stone-v1",
    "wear": 24,
    "obstacles": [
      { "type": "pond", "algo": "line", "min": 6, "max": 6, "sight": "low" },
      { "type": "table", "algo": "line", "min": 6, "max": 6, "sight": "low" },
      { "type": "wall", "algo": "line", "min": 6, "max": 6, "sight": "tall" },
    ],
  },
] as const;
